import { Component, Input } from '@angular/core';
import { DropdownDefinitions } from './model/dropdown-definition.model';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styles: [],
})
export class DropdownComponent {
    @Input() definition: DropdownDefinitions;
}
